/* eslint-disable no-continue */
import {
  editButton,
  copyButton,
  addButton,
  deleteButton,
  refreshButton,
  magnifierButton,
  exportButton
} from '../../XToolbar/XToolbar.fn';

const handlers = [
  {
    keys: ['ENTER', 'F4'],
    itemName: 'edit',
    basicFn: editButton
  },
  {
    keys: ['INSERT'],
    itemName: 'copy',
    basicFn: copyButton,
    shiftKeyReq: true
  },
  {
    keys: ['INSERT'],
    itemName: 'add',
    basicFn: addButton
  },
  {
    keys: ['DELETE'],
    itemName: 'remove',
    basicFn: deleteButton
  },
  {
    keys: ['F8'],
    itemName: 'refresh',
    basicFn: refreshButton
  },
  {
    keys: ['B'],
    itemName: 'previewData',
    basicFn: magnifierButton,
    ctrlKeyReq: true
  },
  {
    keys: ['X'],
    itemName: 'exportData',
    basicFn: exportButton,
    ctrlKeyReq: true
  }
];

const callToolbarItemFn = (
  toolbarOptions,
  itemName,
  defaultItemFn,
  defaultFnParams
) => {
  if (toolbarOptions[itemName] === false) {
    return null;
  }

  if (typeof toolbarOptions[itemName] === 'function') {
    toolbarOptions[itemName]();

    return null;
  }

  defaultItemFn(defaultFnParams);
};

export const keyEventsHandler = ({
  ev,
  toolbarOptions = {},
  title,
  dgInstance,
  rowIndex,
  setAction,
  action,
  setIsLoadingPanelVisible
}) => {
  const { key, shiftKey, ctrlKey } = ev;
  const keyUpper = key.toUpperCase();

  const fnParams = {
    dgInstance,
    rowIndex,
    setAction,
    action,
    title,
    setIsLoadingPanelVisible
  };

  for (let i = 0; i < handlers.length; i++) {
    const { keys, itemName, basicFn, shiftKeyReq, ctrlKeyReq } = handlers[i];

    if (shiftKeyReq && !shiftKey) continue;

    if (ctrlKeyReq && !ctrlKey) continue;

    if (!keys.includes(keyUpper)) continue;

    callToolbarItemFn(toolbarOptions, itemName, basicFn, fnParams);

    return null;
  }
};
